import React from 'react';
import './App-light.css';

// Import the BrowserRouter, Route and Link components
import { BrowserRouter as Router,Switch, Route, Link } from 'react-router-dom'; 

import PrimaryButton from './components/PrimaryButton'

import Nav from './components/Nav';

import Home from './page/Home';
import About from './page/About';
import Share from './page/Share';
import Submit from './page/Submit';
import TipsTricks from './page/TipsTricks';

import Test from './category/Test';
import Ghuda from './category/Ghuda';

import BottomFooter from './components/BottomFooter';

function App() {

  return (
    <Router>

    <div className="App">
        <Nav />
     
        <Route path="/" exact component={Home}/>
        <Route path="/about" component={About} />
        <Route path="/share" component={Share}/>
        <Route path="/submit" component={Submit}/>
        <Route exact path="/test" component={Test}  />
        <Route  path="/ghuda" component={Ghuda}  />
        <Route  path="/tips-n-tricks" component={TipsTricks}  />
      
      <BottomFooter />
        {/* <BottomFooter /> */}
    </div>
    </Router>
  );
}

export default App;
